Components.HbJuly4thLogo = {
    // @ngInject
    controller: function HbLogoComponentController() {
        this.$onInit = function $onInit() {
            this.fillColor = this.hbLogo.fillColor;
        };
    },
    name: 'hbJuly4thLogo',
    templateUrl: 'angular/app/modules/common/ui_components/hb_logo/july_4th/july_4th_logo.html',
    require: {
        hbLogo: '^hbLogo'
    }
};
